module.exports = __webpack_public_path__ + "img/icon-in.70a95bfe.svg";